<div class="message" [innerHtml]="message"></div>
